import { getData } from "../api/api";

import type { QuotaValues } from "./customerPlanService";

export type PackageLimits = {
  /** free, custom or unlimited. */
  packageType: "free" | "custom" | "unlimited" | string;
  unlimited: boolean;
  /** End of the workspace's custom quota, if any. */
  customUntil?: string | null;
  /** The workspace uses the BEAS LLM: the AI analysis cap applies (own LLM lifts it). */
  beasLlmInUse?: boolean;
  /** The workspace uses the BEAS store: storage caps apply (own OpenSearch lifts them). */
  beasStoreInUse?: boolean;
  /** Plan values before own-resource exemptions. */
  planQuotas?: QuotaValues | null;
  maxWorkspaceUsers: number | null;
  aiAnalysisMaxChars: number | null;
  guideStorageMaxBytes: number | null;
  maxSingleGuideBytes: number | null;
  maxDataAdaptors: number | null;
  maxPrepJobs: number | null;
  maxOpenApiCatalogs: number | null;
  maxIngestSettingsItemsPerTab: number | null;
  maxWidgets: number | null;
  maxDashboards: number | null;
  maxDashboardQueries: number | null;
  maxInsightReportJobs?: number | null;
  maxEmbeds?: number | null;
  beasOpenSearchQuotaBytes: number | null;
  beasOpenSearchMaxIndices: number | null;
};

export type GuideStorageUsage = {
  packageType: string;
  usedBytes: number;
  maxBytes: number | null;
  remainingBytes: number | null;
  maxSingleFileBytes: number | null;
  unlimited: boolean;
};

let cachedLimits: PackageLimits | null = null;
let limitsPromise: Promise<PackageLimits> | null = null;

export const packageLimitsService = {
  get: (): Promise<PackageLimits> => {
    if (cachedLimits) {
      return Promise.resolve(cachedLimits);
    }
    if (!limitsPromise) {
      limitsPromise = getData("/workspaces/me/package-limits")
        .then((data) => {
          cachedLimits = data as PackageLimits;
          return cachedLimits;
        })
        .finally(() => {
          limitsPromise = null;
        });
    }
    return limitsPromise;
  },

  clearCache: () => {
    cachedLimits = null;
  },
};
